import { bitcashPrivateRoom } from 'app-view/hooks/use-realtime'

export const useRealTimeTrustNetworkMutualTrust = () => {
  const _mutualTrust = bitcashPrivateRoom.useColyseusState((state) => state.mutualTrust)
  const mutualTrust = _mutualTrust ? _mutualTrust.toArray() : []
  return mutualTrust
}
